import { Component, inject, Injector, input, Input, output, signal } from '@angular/core';
import { IFormInput } from '@mwe/models';
import { ButtonLinkComponent } from '../../../../buttons/button-link/button-link.component';
import { focusFirstInvalidInput } from '@mwe/utils';

@Component({
  selector: 'mwe-form-input-loading-spinner',
  templateUrl: './form-input-loading-spinner.component.html',
  imports: [ButtonLinkComponent],
})
export class FormInputLoadingSpinnerComponent {
  private readonly injector = inject(Injector);

  @Input() inputElem: IFormInput;
  readonly currentValue = input<any>(undefined);
  readonly isValid = input<boolean>(undefined);
  readonly suppressValidityCheckOnSubmit = input<boolean>(false);
  readonly isLoading = output<boolean>();

  readonly state = signal<'loading' | 'submit'>('submit');

  get submitLabel(): string {
    if (typeof this.inputElem.loadingSpinnerOptions.submitLabelKey === 'function') {
      return this.inputElem.loadingSpinnerOptions.submitLabelKey(this.currentValue(), this.isValid());
    }

    return this.inputElem.loadingSpinnerOptions.submitLabelKey;
  }

  get disabled(): boolean {
    if (this.inputElem.loadingSpinnerOptions.disabled) {
      if (typeof this.inputElem.loadingSpinnerOptions.disabled === 'boolean') {
        return this.inputElem.loadingSpinnerOptions.disabled;
      }

      return this.inputElem.loadingSpinnerOptions.disabled(this.currentValue(), this.isValid());
    }

    if (this.inputElem.loadingSpinnerOptions.disabledWhileEmpty) {
      return !this.currentValue();
    }

    return this.inputElem.loadingSpinnerOptions.disabledWhileInvalid ? !this.isValid() : false;
  }

  async submit(): Promise<void> {
    if (!this.isValid() && !this.suppressValidityCheckOnSubmit()) {
      focusFirstInvalidInput(this.injector);
      return Promise.resolve();
    }

    this.state.set('loading');
    this.isLoading.emit(true);
    await this.inputElem.loadingSpinnerOptions.asyncLoadingFunc(this.currentValue());
    this.state.set('submit');
    this.isLoading.emit(false);
  }
}
